import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=4a38b99e"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=ts"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports